import { apiRequest } from './client';
import type { CombatSettings } from '../types';

export function fetchCombatSettings() {
  return apiRequest<CombatSettings>('/api/settings');
}

export function saveArmorFormula(armor_formula: string) {
  return saveArmorFormulas({ armor_formula });
}

export function saveLevelUpSkillPoints(level_up_skill_points: number) {
  return apiRequest<CombatSettings>('/api/settings', {
    method: 'PUT',
    auth: true,
    body: { level_up_skill_points },
  });
}

export function saveArmorFormulas(payload: {
  armor_formula: string;
  armor_formula_spell?: string;
  armor_formula_effect?: string;
}) {
  return apiRequest<CombatSettings>('/api/settings', {
    method: 'PUT',
    auth: true,
    body: payload,
  });
}
